import { ChartFormInstanceType } from "@src/contexts/ab-testing/ab-context";
import { useClickOutside } from "@src/hooks/use-click-outside";
import { useDebounce } from "@src/hooks/use-debounce";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { addNewEvents, EventListDataType } from "@src/util/ab-testing/funnel/manage-state-event-lists";
import { Button, Dropdown, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import { MenuProps } from "antd/lib/menu";
import React from "react";

export const EventStepDropdown: React.FC<{
  dropdownItem: MenuProps["items"];
  form: FormInstance<ChartFormInstanceType>;
  updateField: (newValue: EventListDataType[]) => void;
  isDisabled: boolean;
}> = ({ dropdownItem, form, updateField, isDisabled }) => {
  // const [eventCustomList, setEventCustomList] = React.useState<string[]>([]);
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const [inputSearch, setInputSearch] = React.useState("");
  const inputSearchDebounce = useDebounce(inputSearch, 200);
  const dropdownVisibleRef = React.useRef<NodeJS.Timeout>();
  const dropdownRef = useClickOutside<HTMLDivElement>(() => {
    dropdownVisibleRef.current = setTimeout(() => {
      setInputSearch("");
      setOpenDropdown(false);
    }, 50);
  });
  const selectDropdownRef = React.useRef<HTMLDivElement>(null);

  const _dropdownItem: MenuProps["items"] = React.useMemo(() => {
    return (
      dropdownItem
        // ?.concat(eventCustomList.map((e) => ({ key: e, title: e, label: e })))
        ?.filter((item: any) => !!item?.title && item?.title?.includes(inputSearchDebounce))
    );
  }, [inputSearchDebounce, dropdownItem]);

  const openDropdownDebounce = useDebounce(openDropdown, 50);
  const selectRef = React.useRef<any>();

  const [placement, setPlacement] = React.useState<"top" | "bottom">("bottom");
  React.useEffect(() => {
    if (!openDropdown) return;
    const handleDetectPlacement = () => {
      const dropdownSelect = selectDropdownRef.current;
      const mainDropdown = dropdownRef.current;
      if (dropdownSelect && mainDropdown) {
        const selectDropdownTop = dropdownSelect.getBoundingClientRect().top;
        const mainDropdownTop = mainDropdown.getBoundingClientRect().top;
        if (selectDropdownTop < mainDropdownTop) {
          setPlacement("top");
        } else {
          setPlacement("bottom");
        }
      }
    };
    window.addEventListener("scroll", () => {
      handleDetectPlacement();
    });

    const id = setTimeout(() => {
      handleDetectPlacement();
    }, 400);

    return () => {
      clearTimeout(id);
      window.removeEventListener("scroll", () => {
        handleDetectPlacement();
      });
    };
  }, [dropdownRef, openDropdown, selectDropdownRef]);
  const timeoutIdRef = React.useRef<NodeJS.Timeout>();
  return (
    <Dropdown
      placement={placement}
      open={openDropdownDebounce}
      destroyPopupOnHide
      dropdownRender={() => (
        <div ref={dropdownRef}>
          <Select
            ref={selectRef}
            placeholder="Search event name"
            open={openDropdown}
            mode="tags"
            style={{
              width: 300,
            }}
            value={[]}
            options={_dropdownItem?.map((item: any) => ({ value: item?.key, label: item?.label }))}
            searchValue={inputSearch}
            onSearch={(value) => {
              setInputSearch(value);
            }}
            onClear={() => {
              setInputSearch("");
            }}
            onChange={(value: string[]) => {
              clearTimeout(timeoutIdRef.current);
              timeoutIdRef.current = setTimeout(() => {
                updateField(addNewEvents(form.getFieldValue(ChartFormFieldsEnum.FUNNEL_EVENT_LISTS) ?? [], value[0]));
              }, 50);
            }}
            onBlur={(e) => {
              clearTimeout(timeoutIdRef.current);
            }}
            getPopupContainer={(triggerNode) => triggerNode}
            dropdownRender={(menu) => {
              return <div ref={selectDropdownRef}>{menu}</div>;
            }}
          />
        </div>
      )}
    >
      <Button
        style={{
          paddingLeft: 0,
        }}
        onClick={() => {
          clearTimeout(dropdownVisibleRef.current);
          setOpenDropdown(true);
          setTimeout(() => {
            selectRef.current.focus();
          }, 100);
        }}
        type="link"
      >
        + Add Step
      </Button>
    </Dropdown>
  );
};
